import { Switch, Route, Redirect } from 'react-router-dom';
import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';

import { Spinner } from 'reactstrap';
import { allCustomers, fetchAllCustomers, saveBackupCustomers } from 'store/customer/actions';
import { useDispatch, useSelector } from 'react-redux';
import createCustomerSelector from 'store/customer/selector';
import axios from 'axios';
import { getAllCustomerLogin, invitedTechUsers, isFetching, loginUserData } from 'store/users/actions';
import createUserSelector from 'store/users/selector';
import { FetchAllEquipment, getAllEquipments, getAllFreeEquipments } from 'store/equipment/actions';
import createEquipmentSelector from 'store/equipment/selector';
import createJobSelector from 'store/job/selector';
import { allMemoData, fetchAllJobs, fetchNotifications, getAllJobs, getAllNotifications, getMonitoringData, getRequestedByData, jobStatus, selectChangeOfEquipment, selectInstallationBossUnit, selectInstallationTimeLapse, selectInstallationXseries, selectRelocationData, selectRemovalOrder, selectServicesData, showSelectedInstallationType, totalServices, fetchAllMemo, fetchAllServices, callServicesJobs, getAllChildsJobs } from 'store/job/actions';
import { updateAbility } from 'config/ability';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import socket from 'socket/socket';
import createTemplateSelector from 'store/template/selector';
import { callSMSTemplate, getAllSMSTemplate, callEmailTemplate, getAllEmailTemplate } from 'store/template/actions';
import { callMessageNotification, getMessageNotications } from 'store/Message/actions';
import createMessageNotifySelector from 'store/Message/selector';
import notificationSound from '../assets/sounds/viperplussound.mp3';


const Dashboards = lazy(() => import('../components/Dashboard'));
const Widgets = lazy(() => import('../Theme/Components/Widgets'));
const Elements = lazy(() => import('../Theme/Components/Elements'));
const Forms = lazy(() => import('../Theme/Components/Forms'));
const Tables = lazy(() => import('../Theme/Components/Tables'));
const Components = lazy(() => import('../Theme/Components/Components'));


function isAuthenticated() {
  const token = localStorage.getItem('user');
  return !!token;
}

function ProtectedRoute({ component: Component, path, ...rest }) {

  return (

    <Route
      {...rest}
      render={props => {
        if (!isAuthenticated()) {
          return <Redirect to="/login" />;
        }

        if (isAuthenticated()) {
          return <Redirect to="/dashboard" />;
        }
        return <Component {...props} />;
      }}
    />
  );
}

const PrivateRoutes = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const prevPathRef = useRef(null);
  const { state } = location;
  const jobId = state && state.jobId ? state.jobId : null;
  const jobType = state && state.jobType ? state.jobType : null;
  const customerSelector = useSelector(createCustomerSelector);
  const userSelector = useSelector(createUserSelector);
  const equipmentSelector = useSelector(createEquipmentSelector
  );
  const jobSelector = useSelector(createJobSelector
  );
  const templateSelector = useSelector(createTemplateSelector);
  const messageSelector = useSelector(createMessageNotifySelector);
  const { isFetchingTechnician } = userSelector;
  const { fetchCustomer, allCustomersData } = customerSelector;
  const { fetchEquipments } = equipmentSelector;
  const { fetchAllJobsData, fetchNotification, callMemo, callServices, isCallService } = jobSelector;
  const { isCallSMSTemplate, isCallEmailTemplate } = templateSelector;
  const { isCallMessageNotification } = messageSelector;
  const [csPathLoader, setCSPathLoader] = useState(false);


  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    const { id } = userData;
    const fetchUsers = async () => {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/technician`);
      const loginUser = response.data.users.filter(value => {
        return id === value._id;
      })
      dispatch(loginUserData(loginUser[0]));
      updateAbility(loginUser[0]?.role)

      const sortedTechnician = [...response.data.users]
        .filter(user => user.role !== 'Customer')
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      const sortedLoginCustomer = [...response.data.users]
        // .filter(user => user.role === 'Customer')
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      dispatch(getAllCustomerLogin(sortedLoginCustomer));

      dispatch(invitedTechUsers(sortedTechnician));

      dispatch(isFetching(false));
    }
    if (isFetchingTechnician) {
      fetchUsers();
    }
  }, [isFetchingTechnician]);

  useEffect(() => {
    const fetchCustomers = async () => {
      dispatch(fetchAllCustomers(false));
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer`);

      const sortAllCustomer = [...response.data.customers].sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      dispatch(allCustomers(sortAllCustomer));
      dispatch(saveBackupCustomers(sortAllCustomer));
      setCSPathLoader(false);
    }
    if (fetchCustomer) {
      fetchCustomers();
    }
  }, [fetchCustomer]);

  useEffect(() => {
    const fetchEquipment = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/equipment`);

        // const fetchEquipment = [...response.data.equipmentList].sort((a, b) => {
        //   return new Date(b.createdAt) - new Date(a.createdAt);
        // });
        const fetchEquipment = [...response.data.equipmentList];
        const filteredFreeEquipment = fetchEquipment.filter(val => {
          return val.status === 'Free'
        });
        dispatch(getAllEquipments(fetchEquipment))
        dispatch(getAllFreeEquipments(filteredFreeEquipment));
        dispatch(FetchAllEquipment(false))
      } catch (error) {
        console.error('Error fetching equipment:', error);
      }
    };
    if (fetchEquipments) {
      fetchEquipment();
    }

  }, [fetchEquipments]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job`);

        const sortAllJobs = [...response.data.jobs].sort((a, b) => {
          return new Date(b.createdOn) - new Date(a.createdOn);
        });

        const setLatestJobId = sortAllJobs[0]?.jobId || 'JNO000'
        // Set the highest job ID in localStorage
        localStorage.setItem('lastGeneratedNumber', setLatestJobId);

        dispatch(getAllJobs(sortAllJobs));
        dispatch(getAllChildsJobs(sortAllJobs))
        dispatch(fetchAllJobs(false));
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };
    if (fetchAllJobsData) {
      fetchJobs();
    }

  }, [fetchAllJobsData]);

  useEffect(() => {
    const fetchNotificationsData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/notifications`);
        dispatch(getAllNotifications(response.data.Notifications))
        dispatch(fetchNotifications(false))
      } catch (error) {
        console.error('Error fetching notifations:', error);
      }
    };
    if (fetchNotification) {
      fetchNotificationsData();
    }

  }, [fetchNotification]);

  useEffect(() => {
    const fetchAllServicesData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/services`);
        const sortAllJobs = [...response.data.services].sort((a, b) => {
          return new Date(b.createdOn) - new Date(a.createdOn);
        });
        localStorage.setItem('lastTicketNumber', sortAllJobs.length > 0 ? sortAllJobs[0]?.ticket_number : 'T000');
        dispatch(totalServices(response.data.services));
        dispatch(fetchAllServices(false))

      } catch (error) {
        console.error('Error fetching notifations:', error);
      }
    };

    if (callServices) {
      fetchAllServicesData();
    }

  }, [callServices]);

  useEffect(() => {
    const fetchAllMemoData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/memo`);
        const fetchedMemo = [...response.data.memos].sort((a, b) => {
          return new Date(b.timeStamp) - new Date(a.timeStamp);
        });
        localStorage.setItem('lastMemoNumber', fetchedMemo.length > 0 ? fetchedMemo[0]?.memoNumber : 'MM000');
        dispatch(allMemoData(fetchedMemo));
        dispatch(fetchAllMemo(false))

      } catch (error) {
        console.error('Error fetching notifations:', error);
      }
    };

    if (callMemo) {
      fetchAllMemoData();
    }

  }, [callMemo]);


  //Re-Render 
  useEffect(() => {
    const fetchServices = async () => {
      try {
        // console.log("jobId", jobId)
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/selected/${jobId}`);
        switch (jobType) {
          case 'Relocation':
            dispatch(selectRelocationData(response.data));
            break;
          case 'Services':
            dispatch(selectServicesData(response.data));
            break;
          case 'RemovalOrder':
            dispatch(selectRemovalOrder(response.data));
            break;
          case 'ChangeOfEquipment':
            dispatch(selectChangeOfEquipment(response.data));
            break;
          case 'InstallationXseries':
            dispatch(selectInstallationXseries(response.data));
            break;
          case 'InstallationBossUnit':
            dispatch(selectInstallationBossUnit(response.data));
            break;
          case 'InstallationTimeLapse':
            // dispatch(showSelectedInstallationType(3))
            dispatch(selectInstallationTimeLapse(response.data));
          default:
            break;
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    const resetData = () => {
      dispatch(selectInstallationXseries({}));
      dispatch(selectInstallationBossUnit({}));
      dispatch(selectChangeOfEquipment({}));
      dispatch(selectRelocationData({}));
      dispatch(selectServicesData({}));
      dispatch(selectRemovalOrder({}));
      dispatch(getRequestedByData({}));
      dispatch(getMonitoringData({}));
      dispatch(selectInstallationTimeLapse({}));
      dispatch(showSelectedInstallationType(null));
      dispatch(jobStatus(null));
    };

    if (jobId || isCallService) {
      fetchServices();
      dispatch(callServicesJobs(false));
    } else {
      resetData();
    }
  }, [jobId, isCallService, dispatch]);

  useEffect(() => {
    const fetchEmailTemplate = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/template/email`);
        if (response.status === 200 && response.data.success) {
          dispatch(getAllEmailTemplate(response.data.templates || []))
          dispatch(callEmailTemplate(false));
        }

      } catch (error) {
        console.error('Error fetching notifations:', error);
      }
    };

    if (isCallEmailTemplate) {
      fetchEmailTemplate();
    }

  }, [isCallEmailTemplate]);

  useEffect(() => {
    const fetchSMSTemplate = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/template/sms`);
        if (response.status === 200 && response.data.success) {
          dispatch(getAllSMSTemplate(response.data.templates || []))
          dispatch(callSMSTemplate(false));
        }

      } catch (error) {
        console.error('Error fetching notifations:', error);
      }
    };

    if (isCallSMSTemplate) {
      fetchSMSTemplate();
    }

  }, [isCallSMSTemplate]);


  //Fetch when last page visit customer
  useEffect(() => {
    const lastPath = prevPathRef.current;
    const currentPath = location.pathname;
    if (lastPath === "/customers" && currentPath !== lastPath) {
      setCSPathLoader(true)
      dispatch(fetchAllCustomers(true));
    }

    prevPathRef.current = currentPath;
  }, [location]);

  useEffect(() => {
    const fetchMessageNotify = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/twilio/message-notifications`);
        if (response.status === 200) {
          dispatch(getMessageNotications(response.data.messageNotifications || []));
          dispatch(callMessageNotification(false));
        }

      } catch (error) {
        console.error('Error fetching notifations:', error);
      }
    };

    if (isCallMessageNotification) {
      fetchMessageNotify();
    }

  }, [isCallMessageNotification]);

  // Notification from Viper
  useEffect(() => {
    if (!socket) return;

    socket.on('notification:new', () => {
      dispatch(fetchNotifications(true));
      dispatch(fetchAllJobs(true));
    });

    // Clean up the event listener on component unmount
    return () => {
      socket.off('notification:new');
    };
  }, []);

  //Message Notification from Viper Plus
  const showNotification = () => {
    if (Notification.permission === "granted") {

      const audio = new Audio(notificationSound);
      audio.play().catch(error => {
        console.error("Error playing sound:", error);
      });

    } else if (Notification.permission === "default") {

      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          showNotification();
        }
      });
    }
  };

  useEffect(() => {
    if (!socket) return;

    const handleNewMessage = () => {
      dispatch(callMessageNotification(true));
      showNotification();
    };

    socket.on("whatsapp:message", handleNewMessage);
    socket.on("whatsapp:message-reply", handleNewMessage);
    socket.on("CameraAlarms", handleNewMessage);

    socket.on("whatsapp:message-delete", () => {
      dispatch(callMessageNotification(true));
    });

    return () => {
      socket.off("whatsapp:message", handleNewMessage);
      socket.off("whatsapp:message-reply", handleNewMessage);
      socket.off("CameraAlarms", handleNewMessage);
      socket.off("whatsapp:message-delete");
    };
  }, [socket, dispatch]);

  //Send Subscription Customer to Viper Plus
  const sendSubscribeCSToViperPlus = () => {
    const filteredSubscribeCS = allCustomersData.filter(
      cs => cs.viper_account && cs.loginDetails?.email?.trim() !== ''
    );

    if (!filteredSubscribeCS) return;

    socket.emit("subscribeCustomer", { subscribeCustomers: filteredSubscribeCS });
  };

  useEffect(() => {
    if (allCustomersData.length > 0) {
      sendSubscribeCSToViperPlus();
    }
  }, [allCustomersData]);


  if (csPathLoader) {
    return <div className='d-flex align-items-center justify-content-center'>
      <Spinner>
      </Spinner>
    </div>
  }


  return (
    < Suspense
      fallback={
        < center >
          <Spinner />
          <h6 className="mt-3">Please wait...</h6>
        </center >
      }
    >
      <Switch>
        <ProtectedRoute path="/components" component={Components} />

        <ProtectedRoute path="/forms" component={Forms} />

        <ProtectedRoute path="/tables" component={Tables} />

        <ProtectedRoute path="/elements" component={Elements} />

        <ProtectedRoute path="/widgets" component={Widgets} />

        <ProtectedRoute exact path="/" component={Dashboards} />

        <Route exact path="*" component={Dashboards} />
      </Switch>
    </Suspense >
  )
};

export default PrivateRoutes;
